import React, {useEffect, useRef} from 'react';
import {getConsultantCode, getConsultantName} from './clinitianUtils';
import {Tooltip} from '@mui/material';
import _ from 'lodash';
import API from '../../../app/api';
import {AutocompleteDictionary} from '../autocomplete';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';

function ControlConsultant(props) {
    const controller = new AbortController();

    const init = useRef(true);

    const renderOptionLine = (createParts, option, classes, props, type, allOptions = []) => {
        let optionLabel = getConsultantName(option);
        return <Tooltip
            title={optionLabel + ' (' + getConsultantCode(option) + ')'}
            enterTouchDelay={600} enterDelay={1500}
            placement={'left'} arrow>
            <div {...props} key={'renderOptionLine_' + option.__id}>
                <div>{optionLabel}</div>
            </div>
        </Tooltip>;
    };

    const optionLabel = (option) => {
        return getConsultantName(option);
    };

    useEffect(async () => {
        let newFilter = 'deactivated ne true and availableIn ne null';
        if (props.allowedConsultants) {
            newFilter += ' and availableIn eq \'' + props.allowedConsultants + '\'';
        }

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true and availableIn ne null)`;
        }
        if (!props.loading && init.current &&
            props.findUser &&
            !_.isNil(props.findUser) &&
            _.isNil(props.value)
        ) {
            let userClinician;
            await API.getDictByURL(
                `/consultants?$filter=${encodeURIComponent(newFilter)}`,
                controller.signal,
            ).then((dictData) => {
                if (dictData) {
                    userClinician = _.find(dictData.__data, (clinician) => clinician.userName === props.findUser);
                }
            });

            if (userClinician) {
                props.onChange(userClinician, true);
                init.current = false;
            }
        }

        return () => {
            controller.abort();
        };
    }, [props.value, props.loading]);

    const getDictionaryURL = (filter) => {
        let newFilter = 'deactivated ne true and availableIn ne null';

        if (props.allowedConsultants) {
            newFilter += ' and availableIn eq \'' + props.allowedConsultants + '\'';
        }

        if (props.filterBy && props.filterBy !== '') {
            newFilter = `(${props.filterBy} eq true and deactivated ne true and availableIn ne null)`;
            if (filter !== '') {
                newFilter =
                    `(${props.filterBy} eq true and deactivated ne true and availableIn ne null) and ` + filter;
            }
        } else {
            if (filter !== '') {
                newFilter = 'deactivated ne true and availableIn ne null and ' + filter;
            }
        }
        return `/consultants?$filter=${encodeURIComponent(
            newFilter,
        )}&$sort=familyName`;
    };

    return (
        <AutocompleteDictionary
            showAll
            getOptionSelected={(option, value) => option.__id === value.__id}
            getOptionLabel={optionLabel}
            allowedConsultants={props.allowedConsultants}
            renderLocalOption={renderOptionLine}
            multiSearchColumnName={['familyName', 'firstName']}
            dictionaryURL={getDictionaryURL}
            renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                <Chip
                    label={getConsultantName(option)}
                    {...getTagProps({index})}
                />
            ))
            }
            isOptionEqualToValue={(option, value) => {
                return option?.__id === value?.__id;
            }}
            cliniciansWithNurses={false}
            noBorder={!props.refresh}
            withNewBackground={props.refresh}
            {...props}
            size={props.refresh ? 'large' : props.size || 'small'}
        />
    );
}

ControlConsultant.propTypes = {
    allowedConsultants: PropTypes.string.isRequired,
};

export default ControlConsultant;